/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Feb 02 2024
 **/

import styled from "@emotion/styled";

import { Column } from "@/frameworks/designStuff/components";
import { useProperties } from "@/frameworks/libraries/properties";
import * as S from "../emotion";

type EmoticonType = { text: string; name?: string };

export default function Emoticons({
	emoticon,
	onRemove
}: {
	emoticon: EmoticonType;
	onRemove: (emoticon: EmoticonType) => void;
}) {
	const properties = useProperties();

	return (
		<S.EmoticonWrapper>
			<Emoticon key={emoticon.text} src={`${properties.default.webDomain}${emoticon.text}`}>
				<S.RemoveFile
					id="remove-file"
					name="Close24"
					size="small"
					filled="error"
					fill="neutral_00_100"
					shape="round"
					onClick={() => onRemove(emoticon)}
				/>
			</Emoticon>
		</S.EmoticonWrapper>
	);
}

const Emoticon = styled(Column.li)<{ src: string }>`
	width: 100px;
	height: 100px;
	position: relative;
	background-image: url(${({ src }) => src});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	&:hover {
		#remove-file {
			display: flex !important;
		}
	}
`;
